import { Spinner } from "@visiblethread/react-components";
import { elements } from "constants/types";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { selectJobQueue, selectPageLoading } from "slices/app/selectors";
import { selectConfigLoading as selectDictionarySearchLoading } from "slices/dictionarySearch/selectors";
import { selectConfigLoading } from "slices/discovery/selectors";

const SpinnerWithLoadMask = ({ opacity, fullScreen }) => {
  const jobQueue = useSelector(selectJobQueue);
  const jobQueueEmpty = jobQueue?.length === 0;
  const pageLoadingState = useSelector(selectPageLoading);
  let pageLoading = true;
  if (pageLoadingState !== undefined) {
    pageLoading = pageLoadingState > 0;
  }

  const discoveryConfigLoading = useSelector(selectConfigLoading);
  const dictSearchConfigLoading = useSelector(selectDictionarySearchLoading);
  const showMask =
    (!jobQueueEmpty && fullScreen) ||
    (pageLoading && fullScreen) ||
    (discoveryConfigLoading?.find((load) => load.element === elements.CONTENT)
      ?.loading &&
      !fullScreen) ||
    (dictSearchConfigLoading?.find((load) => load.element === elements.CONTENT)
      ?.loading &&
      !fullScreen);

  return (
    showMask && (
      <Spinner
        opacity={opacity}
        fullScreen={fullScreen}
        size={fullScreen ? "62px" : ""}
      />
    )
  );
};

export default SpinnerWithLoadMask;

SpinnerWithLoadMask.propTypes = {
  opacity: PropTypes.number.isRequired,
  fullScreen: PropTypes.bool.isRequired,
};
